module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Upload Stats with AI")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-tabs', {
    attrs: {
      "fixed-tabs": "",
      "background-color": "primary"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    staticClass: "primary--text",
    staticStyle: {
      "background": "white"
    }
  }, [_vm._v("Use Submitted Stats")]), _vm._v(" "), _c('v-tab', {
    staticClass: "primary--text",
    staticStyle: {
      "background": "white"
    }
  }, [_vm._v("Upload Stats")])], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('v-container', [(!_vm.imagesToView) ? _c('h4', [_vm._v("\n                    Empty Submissions\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.imagesToView) ? _c('div', [(_vm.hasPosts) ? _c('div', {
    staticClass: "pb-5"
  }, [_c('div', {
    staticClass: "h3 mt-2"
  }, [_c('span', [_vm._v("Posts")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.changeContentImage(_vm.imagesToView.posts)
      }
    }
  }, [_c('v-radio-group', {
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "dense": "",
      "row": ""
    },
    model: {
      value: (_vm.checkbox.post),
      callback: function($$v) {
        _vm.$set(_vm.checkbox, "post", $$v)
      },
      expression: "checkbox.post"
    }
  }, [_c('v-radio', {
    staticClass: "justify-center",
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "dense": "",
      "value": "post",
      "label": "Select this Content"
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-divider', {
    staticClass: "ma-0 mb-4"
  }), _vm._v(" "), _vm._l((_vm.imagesToView.posts), function(allPost, firstIndex) {
    return _c('div', {
      key: firstIndex,
      staticClass: "mb-5"
    }, [_c('v-row', {
      attrs: {
        "justify": "start",
        "align": "left"
      }
    }, [_vm._l((allPost.images), function(img, imgIndex) {
      return _c('v-col', {
        key: imgIndex,
        attrs: {
          "md": "4",
          "xs": "12"
        }
      }, [_c('v-card', {
        attrs: {
          "text": "",
          "tile": ""
        }
      }, [_c('v-hover', [(_vm.getMediaType(img.url) === 'video') ? _c('video', {
        attrs: {
          "width": "180px",
          "height": "200px",
          "src": img.url,
          "controls": ""
        }
      }, [_vm._v("             \n                                    Your browser does not support the video tag.\n                                ")]) : _c('v-img', {
        staticClass: "grey lighten-2 mx-auto",
        class: ("elevation-" + (_vm.hover ? 12 : 2)),
        attrs: {
          "src": img.url,
          "lazy-src": img.url,
          "aspect-ratio": "1"
        },
        on: {
          "click": function($event) {
            return _vm.viewMedia(img.url)
          }
        }
      })], 1)], 1)], 1)
    }), _vm._v(" "), (allPost.instagramPostURL !== '' || allPost.images.length > 0) ? _c('v-col', {
      staticClass: "pt-0",
      attrs: {
        "md": "12",
        "xs": "12"
      }
    }, [_c('a', {
      attrs: {
        "href": allPost.instagramPostURL,
        "target": "_blank"
      }
    }, [_c('v-btn', {
      staticClass: "mt-2",
      attrs: {
        "small": "",
        "text": "",
        "color": "warning"
      }
    }, [_vm._v(" " + _vm._s(allPost.instagramPostURL))])], 1)]) : _vm._e()], 2)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasStories) ? _c('div', {
    staticClass: "pb-5"
  }, [_c('div', {
    staticClass: "h3 mt-2"
  }, [_c('span', [_vm._v("IG Stories")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.changeStoryImage(_vm.imagesToView.stories)
      }
    }
  }, [_c('v-radio-group', {
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "dense": "",
      "row": ""
    },
    model: {
      value: (_vm.checkbox.story),
      callback: function($$v) {
        _vm.$set(_vm.checkbox, "story", $$v)
      },
      expression: "checkbox.story"
    }
  }, [_c('v-radio', {
    staticClass: "justify-center",
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "dense": "",
      "value": "story",
      "label": "Select this Content"
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-divider', {
    staticClass: "ma-0 mb-4"
  }), _vm._v(" "), _vm._l((_vm.imagesToView.stories), function(allPost, firstIndex) {
    return _c('div', {
      key: firstIndex,
      staticClass: "mb-5"
    }, [_c('v-row', {
      attrs: {
        "justify": "left",
        "align": "left"
      }
    }, [(allPost.label) ? _c('v-col', {
      staticClass: "mb-0 pb-0",
      attrs: {
        "md": "12",
        "xs": "12"
      }
    }, [_c('div', {
      staticClass: "subtitle-1"
    }, [_vm._v(_vm._s(allPost.label))])]) : _vm._e(), _vm._v(" "), _vm._l((allPost.images), function(img, imgIndex) {
      return _c('v-col', {
        key: imgIndex,
        staticClass: "pt-1",
        attrs: {
          "md": "4",
          "xs": "12"
        }
      }, [_c('v-card', {
        attrs: {
          "text": "",
          "tile": ""
        }
      }, [_c('v-hover', [(_vm.getMediaType(img.url) === 'video') ? _c('video', {
        attrs: {
          "width": "180px",
          "height": "200px",
          "src": img.url,
          "controls": ""
        }
      }, [_vm._v("             \n                                    Your browser does not support the video tag.\n                                ")]) : _c('v-img', {
        staticClass: "grey lighten-2 mx-auto",
        class: ("elevation-" + (_vm.hover ? 12 : 2)),
        attrs: {
          "src": img.url,
          "lazy-src": img.url,
          "aspect-ratio": "1"
        },
        on: {
          "click": function($event) {
            return _vm.viewMedia(img.url)
          }
        }
      })], 1)], 1)], 1)
    })], 2)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasDeliverablePosts) ? _c('div', {
    staticClass: "pb-5"
  }, [_c('div', {
    staticClass: "h3 mt-2"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('v-divider', {
    staticClass: "ma-0 mb-4"
  }), _vm._v(" "), _vm._l((_vm.imagesToView.deliverablePosts), function(allPost, firstIndex) {
    return _c('div', {
      key: firstIndex
    }, [(_vm.filterEmptyPosts(allPost.posts).length > 0) ? _c('div', [_c('div', {
      staticClass: "subtitle-1 font-weight-bold d-flex flex-row justify-space-between"
    }, [_c('span', [_vm._v(_vm._s(_vm.getLongPostTitle(allPost.type)))]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          return _vm.changeContentImage(allPost.posts)
        }
      }
    }, [_c('v-radio-group', {
      staticStyle: {
        "margin-top": "-3px"
      },
      attrs: {
        "dense": "",
        "row": ""
      },
      model: {
        value: (_vm.checkbox.content),
        callback: function($$v) {
          _vm.$set(_vm.checkbox, "content", $$v)
        },
        expression: "checkbox.content"
      }
    }, [_c('v-radio', {
      staticClass: "justify-center",
      staticStyle: {
        "font-size": "13px"
      },
      attrs: {
        "dense": "",
        "value": ("content" + firstIndex),
        "label": "Select this Content"
      }
    })], 1)], 1)]), _vm._v(" "), _vm._l((_vm.filterEmptyPosts(allPost.posts)), function(post, pIndex) {
      return _c('v-row', {
        key: pIndex,
        attrs: {
          "justify": "left",
          "align": "left"
        }
      }, [(post.label && _vm.getPostType(allPost.type) === 'label') ? _c('v-col', {
        staticClass: "pt-5 pb-0",
        attrs: {
          "md": "12",
          "xs": "12"
        }
      }, [(_vm.getPostType(allPost.type) === 'label') ? _c('div', {
        staticClass: "subtitle-2"
      }, [_vm._v(_vm._s(post.label))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((post.images), function(img, imgIndex) {
        return _c('v-col', {
          key: imgIndex,
          attrs: {
            "md": "4",
            "xs": "12"
          }
        }, [_c('v-card', {
          attrs: {
            "text": "",
            "tile": ""
          }
        }, [_c('v-hover', [(_vm.getMediaType(img.url) === 'video') ? _c('video', {
          attrs: {
            "width": "180px",
            "height": "200px",
            "src": img.url,
            "controls": ""
          }
        }, [_vm._v("             \n                                      Your browser does not support the video tag.\n                                  ")]) : _c('v-img', {
          staticClass: "grey lighten-2 mx-auto",
          class: ("elevation-" + (_vm.hover ? 12 : 2)),
          attrs: {
            "src": img.url,
            "lazy-src": img.url,
            "aspect-ratio": "1"
          },
          on: {
            "click": function($event) {
              return _vm.viewMedia(img.url)
            }
          }
        })], 1)], 1)], 1)
      }), _vm._v(" "), (post.label && _vm.getPostType(allPost.type) === 'url') ? _c('v-col', {
        staticClass: "pt-0",
        attrs: {
          "md": "12",
          "xs": "12"
        }
      }, [_c('a', {
        attrs: {
          "href": post.label,
          "target": "_blank"
        }
      }, [_c('v-btn', {
        staticClass: "mt-2",
        attrs: {
          "small": "",
          "text": "",
          "color": "warning"
        }
      }, [_vm._v(" " + _vm._s(post.label))])], 1)]) : _vm._e()], 2)
    }), _vm._v(" "), _c('v-divider', {
      staticClass: "mb-4"
    })], 2) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.imagesToView.images && _vm.imagesToView.images.length > 0) ? _c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, _vm._l((_vm.imagesToView.images), function(img) {
    return _c('v-col', {
      key: img.index,
      attrs: {
        "md": "4",
        "xs": "12"
      }
    }, [_c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('v-hover', [(_vm.getMediaType(img.url) === 'video') ? _c('video', {
      attrs: {
        "width": "180px",
        "height": "200px",
        "src": img.url,
        "controls": ""
      }
    }, [_vm._v("             \n                                Your browser does not support the video tag.\n                            ")]) : _c('v-img', {
      staticClass: "grey lighten-2 mx-auto",
      class: ("elevation-" + (_vm.hover ? 12 : 2)),
      attrs: {
        "src": img.url,
        "lazy-src": img.url,
        "aspect-ratio": "1"
      },
      on: {
        "click": function($event) {
          return _vm.viewMedia(img.url)
        }
      }
    })], 1)], 1)], 1)
  }), 1) : _vm._e()], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-tab-item', [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": "*",
      "multiple": true,
      "listMedia": _vm.media
    },
    on: {
      "change": _vm.mediaChanged
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.uploadMedias.length || _vm.selectedImages.length) ? _c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.extractData()
      }
    }
  }, [_vm._v("\n                  Extract with AI\n                ")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.dataResult) ? _c('div', [(_vm.postType === 'tiktok') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Play Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.total_play_time || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Average Watch Time (s):")]), _c('span'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.average_watch_time_seconds || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.likes || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.comments || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.shares || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Favourites (Bookmarks):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.bookmarks || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Plays (Views):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.video_views || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Viewers (Reach):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.reached || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Watched full video (%):")]), _vm._v(" "), (_vm.dataResult.watched_full_video_percentage) ? _c('span', [_vm._v(_vm._s(_vm.dataResult.watched_full_video_percentage) + "%")]) : _c('span', [_vm._v("N/A")])])])], 1) : (_vm.postType === 'reel') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Accounts Reached:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.reached || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Plays (Views):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.video_views || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.likes || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Saves (Bookmarks):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.bookmarks || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.shares || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.comments || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Play Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.total_play_time || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Average Watch Time:")]), _vm._v(" "), (_vm.dataResult.reel_watch_time) ? _c('span', [_vm._v(_vm._s(_vm.dataResult.reel_watch_time))]) : _c('span', [_vm._v("N/A")])])])], 1) : (_vm.postType === 'story') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Accounts Reached:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.reached || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Impressions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.impressions || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Replies:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.replies || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.shares || ''))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Link Clicks:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.link_clicks))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Sticker Taps:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.sticker_taps || ''))])])])], 1) : _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.dataResult.average_watch_time_seconds) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Average Watch Time (s):")]), _c('span'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.average_watch_time_seconds) + "s")])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.likes) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.likes))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.comments) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.comments))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.new_followers) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Followers:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.new_followers))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.shares) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.shares))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.bookmarks) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Saved:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.bookmarks))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.video_views) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.video_views))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.reached) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Reached:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.reached))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.replies) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Replies:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.replies))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.link_clicks) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Link Clicks:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.link_clicks))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.link_clicks) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Sticker Taps:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.sticker_taps))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.total_interactions) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.total_interactions))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.total_play_time) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Play Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.total_play_time))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.watched_full_video_percentage) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Average Watch Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.watched_full_video_percentage) + "%")])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.reel_watch_time) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Average Watch Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.reel_watch_time))])]) : _vm._e()])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), (_vm.dataResult) ? _c('v-btn', {
    staticClass: "success",
    on: {
      "click": _vm.confirmStats
    }
  }, [_vm._v("Proceed")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "700"
    },
    model: {
      value: (_vm.imageViewerDialog),
      callback: function($$v) {
        _vm.imageViewerDialog = $$v
      },
      expression: "imageViewerDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": function($event) {
        _vm.imageViewerDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-center"
  }, [_c('v-img', {
    attrs: {
      "src": _vm.activeImage
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.activeImage,
      "download": "",
      "target": "_blank"
    }
  }, [_c('v-btn', [_c('v-icon', {
    attrs: {
      "float-left": ""
    }
  }, [_vm._v("save_alt")]), _vm._v("Download")], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05776351"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/campaign/UploadStatsModal.vue
// module id = 1978
// module chunks = 0